const ExternalUrlCell = ({ url, label = null }) => <a href={url} target="_blank">{label ? label : url}</a>

export default ExternalUrlCell